



























import { defineComponent } from 'vue';

import { isIPad, isMobile } from '@/helpers/variables';
import { mapActions, mapGetters, mapMutations } from 'vuex';

import Hidden from '@/components/@general/Hidden/index.vue';
import Header from '@/components/@general/Header/index.vue';
import Footer from '@/components/@general/Footer/index.vue';
import IconScrollTop from '@/components/icons/IconScrollTop.vue';
import MessengerBlock from '@/components/custom/MessengerBlock/index.vue';
import { DEFAULT_LOCALE } from '@/locales/locales';
import { EU_LANGUAGES, tryGetUserGeolocation } from '@/helpers';
import { storage } from '@/utils/storage';
// import { ru, ua } from '@/locales/lang';
// @ts-ignore
// import { events } from 'vue-i18n-manager';
//
// let translations: any = { ru, ua };

export default defineComponent({
  name: 'app',
  data() {
    return {};
  },
  components: {
    MessengerBlock,
    IconScrollTop,
    Hidden,
    Header,
    Footer
  },
  created() {
    if (this.isAuthenticated) {
      this.fetchUser();
      this.getFavorites();
    }
    this.getVariables();

    // this._loadTranslations();
  },
  mounted() {
    if (!isMobile.any()) {
      document.querySelector('body')?.classList.add('hover');
    }
    if (!isIPad.iOS()) {
      document.querySelector('body')?.classList.add('iPad');
    }
    window.onresize = () => {
      this.setResize({ w: window.innerWidth, h: window.innerHeight });
    };

    tryGetUserGeolocation().then((result) => {
      if (result && result.country_code !== 'UA') {
        let findCountyLang = EU_LANGUAGES.find((item) => item.countyCode === result.country_code);
        this.modalSetData({
          key: 'redirectLangModal',
          data: findCountyLang || null
        });
        setTimeout(() => {
          this.modalOpen('redirectLangModal');
        }, 5000);
      } else {
        let status = storage.getItem('disabled_lang_modal');
        if (this.currentLanguage.code === DEFAULT_LOCALE && !status) {
          setTimeout(() => {
            this.modalOpen('langModal');
          }, 5000);
        }
      }
    });
  },
  watch: {
    isAllRequestsCompleted: {
      immediate: true,
      handler(newVal) {
        if (newVal === true) {
          setTimeout(() => {
            // @ts-ignore
            window.prerenderReady = true;
          }, 1000);
        }
      }
    }
  },
  computed: {
    ...mapGetters(['currentLanguage', 'languages']),
    ...mapGetters({
      isAllRequestsCompleted: 'isAllRequestsCompleted',
      isAuthenticated: `auth/isAuthenticated`,
      variables: `setting/variables`
    })
  },
  methods: {
    ...mapMutations({
      setResize: 'app/SET_RESIZE',
      modalOpen: 'app/MODAL_OPEN',
      modalSetData: 'app/MODAL_SET_DATA'
    }),
    ...mapActions({
      fetchUser: 'profile/FETCH_USER_DATA',
      getFavorites: 'favorites/GET_FAVORITES_LIST',
      getVariables: 'setting/GET_VARIABLES',
      getTranslations: 'setting/GET_TRANSLATIONS'
    }),
    // _loadTranslations() {
    //   let { code, translationKey } = this.currentLanguage;
    //   // @ts-ignore
    //   this.$store.commit('setting/SET_TRANSLATIONS', translations[translationKey]);
    //   setTimeout(() => {
    //     this.getTranslations().then((result) => {
    //       console.log('this', this);
    //       // @ts-ignore
    //       this.$store.dispatch(events.SET_TRANSLATION, code);
    //       console.log('_loadTranslations', this.currentLanguage, result);
    //     });
    //   }, 5000);
    // },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
});
